
(function () {
    'use strict';

    angular.module('customeDirectivesModule')
		.directive('npCollapse', npCollapse)
		.directive('npCollapse3', npCollapse3);

    function npCollapse() {
        var directive = {
            restrict: 'EA',
            replace: true,
            template: '<a href="" class="collapse-arrow pointer" ng-click="vm.collapsed()"><span class="hide-link-text">kollapse</span></a>',
            scope: {
                collapseTarget: '@'
            },
            link: linkFunction,
            controller: ['$scope', controller],
            controllerAs: 'vm'
        };

        return directive;

        function linkFunction(scope, el, attr, ctrl) {
            
        };

        function controller($scope) {
            var vm = this;

            vm.collapsed = collapsed;

            function collapsed() {
                angular.element('#' + $scope.collapseTarget).toggleClass('collapsed');
                angular.element('#' + $scope.collapseTarget + '_icon').toggleClass('collapsed-arrow').toggleClass('collapse-arrow');
            };
        };
	};

	function npCollapse3() {
		var directive = {
			restrict: 'E',
			replace: true,
			template: '<span class=" pointer" ng-class="{\'collapse-arrow\' : !collapsedFlag, \'collapsed-arrow\': collapsedFlag}" ng-click="vm.collapsed()"></span>',
			scope: {
				collapseTarget: '@',
				onCollapsed: '&',
				collapsedFlag: '='
			},
			link: linkFunction,
			controller: ['$scope', controller],
			controllerAs: 'vm'
		};

		return directive;

		function linkFunction(scope, el, attr, ctrl) {

		};

		function controller($scope) {
			var vm = this;
			vm.collapsedFlag = angular.copy($scope.collapsedFlag);
			vm.collapsed = collapsed;

			function collapsed() {
				vm.collapsedFlag = !vm.collapsedFlag;
				angular.element('#' + $scope.collapseTarget).toggleClass('collapsed');
				angular.element('#' + $scope.collapseTarget + '_icon').toggleClass('collapsed-arrow').toggleClass('collapse-arrow');
				$scope.onCollapsed({ collapsedFlag: vm.collapsedFlag });
			};

		};
	};

})();